import { Appearance, CssFontSource, CustomFontSource } from '@stripe/stripe-js';
import { StripeCardBrands } from './stripe-instance-class';

export class StripeConfig {
  publishableKey: string | null;
  appearance: Appearance;
  fonts: Array<CssFontSource | CustomFontSource>;
  elementId: string;
  allowedCardBrands: StripeCardBrands[];

  constructor(publishableKey: string) {
    this.elementId = 'paymentElement';
    this.publishableKey = publishableKey;
    this.appearance = {
      theme: 'flat',
      variables: {
        colorPrimaryText: '#1c1c1b',
        borderRadius: '0.375rem',
        colorDanger: '#c94a5b',
        colorBackground: '#fff',
        focusBoxShadow: 'none',
        focusOutline: 'none',
      },
      rules: {
        '.Input': {
          border: '1px solid rgba(72, 89, 102, 0.7)',
          transition: 'none',
        },
        '.Input--invalid': {
          border: '1px solid var(--colorDanger)',
          boxShadow: 'none',
        },
        '.Input:focus': {
          border: '1px solid black',
        },
        '.Error': {
          fontSize: '0.75rem',
        },
        // See all supported class names and selector syntax below
      },
    };
    this.fonts = [
      {
        family: 'Sarabun',
        src: 'url(./Sarabun-Light.woff2) format("woff2"), url(./Sarabun-Light.woff) format("woff")', //todo
        display: 'swap',
      },
    ];
    this.allowedCardBrands = [
      StripeCardBrands.Visa,
      StripeCardBrands.Mastercard,
    ];
  }
}
